import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
//export array
export const icons = [faChevronUp, faChevronDown, faSpinner, faInfoCircle];
